import { Box, Typography } from '@mui/material'
import { StyledCard } from 'candidate/pages/Dashboard/styled'
import React, { ReactNode } from 'react'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
    title: string
    children?: ReactNode
    onClick?: () => void
}

const DashboardCard: React.FC<Props> = ({
    title,
    children,
    onClick,
    ...props
}: Props) => {
    return (
        <StyledCard
            onClick={onClick}
            role={onClick ? 'button' : undefined}
            tabIndex={onClick ? 0 : undefined}
            onKeyDown={(e) => {
                if (e.key === 'Enter' && onClick) {
                    onClick()
                }
            }}
            {...props}
        >
            <Typography variant="h6">{title}</Typography>

            <Box
                sx={{
                    display: 'flex',
                    flex: '1',
                    flexDirection: 'column',
                    overflowY: 'auto',
                }}
            >
                {children}
            </Box>
        </StyledCard>
    )
}

export default DashboardCard
